import React,{Component} from 'react';
import { Spin, Table, Switch, Modal, Row, Col, Form, Select, message,
    Dropdown, Button, Menu, Checkbox, Input, InputNumber, Slider, Divider } from 'antd';
import RPC from 'api';
import {Icon, LabelInput, LabelText} from 'libs';
import {LangConsumer} from 'utils/LangProvider';
import Ability from '../../../../ability';
import WebApp from '../../../../webapp';
import {grep} from '../../../../common';
import _ from 'lodash';
import './index.less';

class OsdOverlay extends React.Component {
    /**用来存放组件内状态 */
    constructor (props) {
        super(props);
        this.ComponentName = 'OsdOverlay';

    }
    /**此时获取异步数据 */
    componentDidMount () {
    }
    /**
     * 获取进入人数/离开人数/内部人数的状态值
     * @param {string} type 类型
     */
    getChecked = (type) => {
        let {$t,
            rule,
            osdCfg
        } = this.props;
        if (rule.Type === 'StereoNumberStat') {
            //osd总使能开启，进入离开关闭时，默认将进入离开勾选上
            if (osdCfg && osdCfg.EncodeBlend && !osdCfg.ShowEnterNum && !osdCfg.ShowExitNum && !osdCfg.ShowInsideNum) {
                if (type === 'ShowEnterNum' || type === 'ShowExitNum') {
                    return true;
                }
            } else {
                return osdCfg.EncodeBlend && osdCfg[type];
            }
        } else {
            return osdCfg.EncodeBlend && osdCfg[type];
        }
    }
    /**
     * 修改进入人数/离开人数/内部人数的值
     * @param {string} type 类型
     * @param {boolean} value 值
     */
    changeChecked = (type, value) => {
        let {$t,
            rule,
            currentChannel,
            osdCfg,
            jsonMap,
            updateJsonMap
        } = this.props;
        if (rule.Type === 'StereoNumberStat') {
            osdCfg.ShowInsideNum = false;
            // 对于这种情况要特殊处理，原因是由于底下的if处理导致
            if (osdCfg.EncodeBlend === false && osdCfg.ShowEnterNum === true && osdCfg.ShowExitNum === true) {
                osdCfg.ShowEnterNum = false;
                osdCfg.ShowExitNum = false;
            }
            osdCfg[type] = value;
            osdCfg.EncodeBlend = osdCfg.ShowEnterNum || osdCfg.ShowExitNum;
            if (!osdCfg.EncodeBlend) {
                osdCfg.ShowEnterNum = true;
                osdCfg.ShowExitNum = true;
            }
        } else {
            osdCfg.ShowEnterNum = false;
            osdCfg.ShowExitNum = false;
            osdCfg.ShowInsideNum = value;
            osdCfg.EncodeBlend = osdCfg.ShowInsideNum;
            if (!osdCfg.EncodeBlend) {
                osdCfg.ShowInsideNum = true;
            }
        }
        jsonMap.VideoWidgetNumberStat[currentChannel] = osdCfg;
        updateJsonMap(_.clone(jsonMap));
    }
    /**
    * [description]osd清零
    * @return {[type]} [description]
    */
    onClearZero = () => {
        RPC.VideoStatServer.clearSectionStat();
    }
    render () {
        let {$t,
            rule,
            osdCfg
        } = this.props;
        const configFormLayout = {
            labelCol: {
                span: 8
            },
            wrapperCol: {
                span: 16
            }
        };
        return (
            <Form labelAlign={'left'} {...configFormLayout}>
                {/*OSD叠加*/}
                {/* <Row>
                    <Form.Item label={$t('med.OsdOverlay')}>
                        {rule.Type === 'StereoNumberStat' ?
                            <Button onClick={this.onClearZero}>{$t('ivs.ClearZero')}</Button> : null}
                    </Form.Item>
                </Row> */}
                {/*进入人数*/}
                {rule.Type === 'StereoNumberStat' ? <Row>
                    <Form.Item label={$t('ivs.MaxEnter')}>
                        <Switch
                            checked={this.getChecked('ShowEnterNum')}
                            onChange={this.changeChecked.bind(this, 'ShowEnterNum')}/>
                    </Form.Item>
                </Row> : null}
                {/*离开人数*/}
                {rule.Type === 'StereoNumberStat' ? <Row>
                    <Form.Item label={$t('com.Peopleout')}>
                        <Switch
                            checked={this.getChecked('ShowExitNum')}
                            onChange={this.changeChecked.bind(this, 'ShowExitNum')}/>
                    </Form.Item>
                </Row> : null}
                {/*内部人数*/}
                {rule.Type === 'ManNumDetection' ? <Row>
                    <Form.Item label={$t('ivs.InsideNumber')}>
                        <Switch
                            checked={this.getChecked('ShowInsideNum')}
                            onChange={this.changeChecked.bind(this, 'ShowInsideNum')}/>
                    </Form.Item>
                </Row> : null}
                <Divider/>
            </Form>
        );
    }
}

export default LangConsumer(Form.create({name: 'OsdOverlay'})(OsdOverlay));